import useSEO from '../hooks/useSEO';
import ProcesoArrendamiento from '../assets/images/linea tiempo de proceso de arrendamiento.jpeg';

const ProcessPage = () => {
  
  

  useSEO({
    title: 'Proceso de Arrendamiento - J&D Propiedad Raíz',
    description: 'Conoce el proceso completo para arrendar un inmueble con J&D Propiedad Raíz. Pasos claros, rápidos y seguros para encontrar tu próximo hogar.',
    keywords: 'proceso arrendamiento, arrendar inmueble, pasos arriendo, J&D Propiedad Raíz, alquiler Colombia',
    ogTitle: 'Proceso de Arrendamiento - J&D Propiedad Raíz',
    ogDescription: 'Descubre cómo es nuestro proceso de arrendamiento: simple, rápido y confiable. Tu próximo hogar te está esperando.',
    ogImage: 'https://jdpropiedadraiz.co/logo192.png'
  });

  return (
    <div className="min-h-screen bg-brand-black text-brand-white relative overflow-hidden">
      
      {/* Background with animated elements and watermarks */}
      <div className="fixed inset-0 pointer-events-none">
        {/*<div className="absolute inset-0 bg-gradient-to-br from-brand-black via-brand-black to-brand-gold/5 "></div>*/}
        
        {/* Floating logo watermarks */}
        <div className="absolute top-20 left-10 opacity-5 transform rotate-12 ">
          <img src="/logo192.png" alt="" className="w-32 h-32 filter brightness-0 invert" />
        </div>
        <div className="absolute top-1/3 right-20 opacity-3 transform -rotate-12 ">
          <img src="/logo192.png" alt="" className="w-24 h-24 filter brightness-0 invert" />
        </div>
        <div className="absolute bottom-2/4 left-1/4 opacity-4 transform rotate-45 " style={{animationDelay: '1s'}}>
          <img src="/logo192.png" alt="" className="w-20 h-20 filter brightness-0 invert" />
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-6 z-10">
        <div className="container mx-auto max-w-4xl text-center">
          <h1 
            data-animate="fade-up"
            className={`text-5xl md:text-6xl font-bold mb-6 text-brand-gold `}
          >
            Proceso de Arrendamiento
          </h1>
          <p 
            data-animate="fade-in"
            className={`text-xl md:text-2xl text-brand-gray leading-relaxed `}
          >
            Conoce nuestro proceso simple, rápido y confiable para arrendar tu próximo hogar
          </p>
        </div>
      </section>

      {/* Process Timeline Image Section */}
      <section className="py-20 px-6 relative z-10">
        <div className="container mx-auto max-w-7xl">
          
          {/* Introduction */}
          <div 
            data-animate="fade-up"
            className={`text-center mb-16 `}
          >
            <h2 className="text-4xl font-bold mb-6 text-brand-gold">
              Línea de Tiempo del Proceso
            </h2>
            <p className="text-xl text-brand-gray max-w-3xl mx-auto leading-relaxed">
              Desde la búsqueda hasta la entrega de llaves, cada paso está diseñado para brindarte una experiencia <span className="text-brand-gold font-semibold">segura, transparente y eficiente</span>.
            </p>
          </div>

          {/* Process Image */}
          <div 
            data-animate="zoom-in"
            className={`relative `}
          >
            <div className="bg-brand-gold/10 p-8 rounded-2xl border border-brand-gold/20 backdrop-blur-sm relative overflow-hidden">
              <div className="absolute top-4 left-4 opacity-5">
                <img src="/logo192.png" alt="" className="w-16 h-16 filter brightness-0 invert" />
              </div>
              <div className="absolute bottom-4 right-4 opacity-5 transform rotate-180">
                <img src="/logo192.png" alt="" className="w-16 h-16 filter brightness-0 invert" />
              </div>
              
              <div className="relative z-10">
                <img 
                  src={ProcesoArrendamiento} 
                  alt="Línea de tiempo del proceso de arrendamiento con J&D Propiedad Raíz"
                  className="w-full h-auto rounded-lg shadow-2xl shadow-brand-gold/10 transition-transform duration-300 hover:scale-[1.02]"
                />
              </div>
            </div>
          </div>

          {/* Additional Information */}
          <div 
            data-animate="slide-up"
            className={`mt-16 grid md:grid-cols-2 gap-8 `}
          >
            <div className="bg-brand-gold/5 p-8 rounded-xl border border-brand-gold/20 backdrop-blur-sm relative overflow-hidden">
              <div className="absolute top-2 right-2 opacity-10">
                <img src="/logo192.png" alt="" className="w-12 h-12 filter brightness-0 invert" />
              </div>
              <h3 className="text-2xl font-bold text-brand-gold mb-4">
                ¿Por qué elegir nuestro proceso?
              </h3>
              <ul className="space-y-3 text-brand-gray">
                <li className="flex items-start">
                  <span className="text-brand-gold mr-3 mt-1">✓</span>
                  <span><strong className="text-brand-white">100% Digital:</strong> Gestiona todo desde tu celular o computador</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-gold mr-3 mt-1">✓</span>
                  <span><strong className="text-brand-white">Transparente:</strong> Conoce cada paso del proceso</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-gold mr-3 mt-1">✓</span>
                  <span><strong className="text-brand-white">Rápido:</strong> Proceso optimizado para ahorrarte tiempo</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-gold mr-3 mt-1">✓</span>
                  <span><strong className="text-brand-white">Seguro:</strong> Respaldo legal y asesoría profesional</span>
                </li>
              </ul>
            </div>

            <div className="bg-brand-gold/5 p-8 rounded-xl border border-brand-gold/20 backdrop-blur-sm relative overflow-hidden">
              <div className="absolute top-2 right-2 opacity-10">
                <img src="/logo192.png" alt="" className="w-12 h-12 filter brightness-0 invert" />
              </div>
              <h3 className="text-2xl font-bold text-brand-gold mb-4">
                ¿Necesitas ayuda?
              </h3>
              <p className="text-brand-gray mb-6 leading-relaxed">
                Nuestro equipo de asesores está disponible para acompañarte en cada paso del proceso y resolver todas tus dudas.
              </p>
              <a
                href="https://wa.me/573102390002?text=Hola,%20quiero%20información%20sobre%20el%20proceso%20de%20arrendamiento"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-brand-gold text-brand-black px-6 py-3 rounded-lg font-semibold hover:bg-brand-gold/90 transition-all duration-300 transform hover:scale-105 inline-flex items-center hover:shadow-lg hover:shadow-brand-gold/25"
              >
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.515z"/>
                </svg>
                Contactar Asesor
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 px-6 relative z-10">
        <div className="container mx-auto max-w-4xl text-center">
          <div 
            data-animate="slide-up"
            className={`bg-gradient-to-r from-brand-gold/10 to-brand-gold/5 p-12 rounded-2xl border border-brand-gold/20 backdrop-blur-sm relative overflow-hidden hover:transform hover:scale-[1.02] transition-all duration-300 `}
          >
            <div className="absolute inset-0 opacity-3">
              <div className="absolute top-6 left-6 transform rotate-12">
                <img src="/logo192.png" alt="" className="w-16 h-16 filter brightness-0 invert" />
              </div>
              <div className="absolute bottom-6 right-6 transform -rotate-12">
                <img src="/logo192.png" alt="" className="w-16 h-16 filter brightness-0 invert" />
              </div>
            </div>
            <h3 className="text-3xl font-bold mb-6 text-brand-gold relative z-10">
              ¿Listo para encontrar tu próximo hogar?
            </h3>
            <p className="text-xl text-brand-gray mb-8 leading-relaxed relative z-10">
              Explora nuestras propiedades disponibles y comienza tu proceso de arrendamiento hoy mismo.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center relative z-10">
              <a 
                href="/inmuebles/arriendo/0-999999999999/" 
                rel="noopener noreferrer"
                className="bg-brand-gold text-brand-black px-8 py-4 rounded-lg font-semibold hover:bg-brand-gold/90 transition-all duration-300 transform hover:scale-105 inline-block text-center hover:shadow-lg hover:shadow-brand-gold/25"
              >
                Ver Propiedades en Arriendo
              </a>
              <a 
                href="/nosotros" 
                rel="noopener noreferrer"
                className="border-2 border-brand-gold text-brand-gold px-8 py-4 rounded-lg font-semibold hover:bg-brand-gold hover:text-brand-black transition-all duration-300 inline-block text-center hover:shadow-lg hover:shadow-brand-gold/25"
              >
                Conocer Más
              </a>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default ProcessPage;
